import {Serializable} from "./Serializable";

export class LocalStorage<T> {
	constructor(
		readonly key: string,
		readonly formatter: (value: T) => string,
		readonly parser: (json: string) => T,
		readonly useSessionStorage?: boolean,
	) {
	}
	
	getStorage(): Storage{
		return this.useSessionStorage ? window.sessionStorage : window.localStorage;
	}
	get(): T | null {
		const data =  this.getStorage().getItem(this.key);
		if (!data)
			return null;
		try {
			return this.parser(data);
		} catch (error) {
			// todo error handling
			console.error(error);
			this.getStorage().removeItem(this.key);
			return null;
		}
	}
	
	set(value: T | null) {
		if (value == null) {
			this.getStorage().removeItem(this.key);
		} else {
			const data = this.formatter(value);
			this.getStorage().setItem(this.key, data);
		}
	}
}

export function localStorageOfSerializable<T extends Serializable>(
	key: string,
	parser: (json: any) => T,
	useSessionStorage?: boolean
) {
	return new LocalStorage<T>(
		key,
		value => JSON.stringify(value.serialize()),
		data => parser(JSON.parse(data)),
		useSessionStorage
	);
}

export function localStorageOfString(key: string, 	sessionStorage?: boolean) {
	return new LocalStorage<string>(
		key,
		value => value,
		data => data,
		sessionStorage
	);
}

export function localStorageOfObject(key: string,	sessionStorage?: boolean) {
	return new LocalStorage<any>(
		key,
		value => JSON.stringify(value),
		data => JSON.parse(data),
		sessionStorage
	);
}
